// src/components/Layout.jsx
import React, { useState } from 'react';
import { MenuIcon, XIcon } from '@heroicons/react/outline';

export default function Layout({ sidebar, children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Mobile sidebar toggle */}
      <div className="md:hidden flex items-center">
        <button
          className="m-4 p-2 focus:outline-none"
          onClick={() => setSidebarOpen(true)}
        >
          <MenuIcon className="w-6 h-6 text-gray-700" />
        </button>
      </div>

      {/* Mobile sliding panel */}
      <aside
        className={`fixed inset-y-0 left-0 w-64 bg-white shadow-xl transform ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-300 ease-in-out z-40 md:hidden`}
      >
        <button
          className="absolute top-4 right-4 p-2 focus:outline-none"
          onClick={() => setSidebarOpen(false)}
        >
          <XIcon className="w-6 h-6 text-gray-700" />
        </button>
        <div className="mt-12 overflow-y-auto h-full">
          {sidebar}
        </div>
      </aside>

      {/* Backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-30 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Desktop sidebar */}
      <aside className="hidden md:block md:fixed md:inset-y-0 md:left-0 md:w-64 bg-white border-r overflow-y-auto">
        <div className="mt-6">
          {sidebar}
        </div>
      </aside>

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden md:pl-64">
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
